import axios from 'axios'
import  messages  from '@/utils/ErrorMessages';
import { notify } from '@kyvg/vue3-notification';

export default {
    namespaced: true,

    state: () => ({
        channels: [],
        loading: false,
    }),
    getters:{
        isLoading(state){
            return state.loading
        },
        allChannels(state){
            return state.channels
        },
        prepareChannels(state) {
            return state.channels.map(channel => ({
                option: channel.id,
                description: channel.name,
            }))
        },
        getById: (state) => (id) => {
            return state.channels.find( item => item.id === id )
        },
        getNameByIds: (state) => (ids = []) => {
            return state.channels.filter((item) => ids.includes(item.id)).map((itemmap) => itemmap.name )
        },
    },
    mutations: {
        save: (state, payload) => state.channels = payload,

        STORE_CHANNELS(state, channels) {
            state.channels = channels
        },
    },

    actions: {
        async fetchChannels({commit}){
            this.loading = true
            axios.get('/v1/channels')
            .then(response => {
                commit('save', response.data.data)
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            }).finally(() => {
                this.loading = false
            })
        },
    },
};
